// extracted by mini-css-extract-plugin
export default {"chip":"ActivityTypeChip_chip__j1IjN"};